<template>
  <material-card
    :title="$t('globals.history')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="work"
  >
    <v-card-text>
      <pbas-data-table
        :exporters="$exporters"
        ref="table"
        :dataProvider="provider"
        fileNamePrefix="employersHistory"
        identifier="employersHistoryTable"
        @error="error = $event"
        :showSelect="false"
      ></pbas-data-table>
    </v-card-text>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import EmployersHistoryHeaders from "@/headers/EmployersHistory";
export default {
  props: ["employerId"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      error: null,
      provider: undefined,
      headers: EmployersHistoryHeaders,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    loadPlanData() {
      let url = "plans/" + this.selectedPlan.Id + "/employers/" +this.employerId +"/history";
      this.provider = new ODataProvider(this.$axiosHttp, url, this.headers);
    },
    getDataAsync() {
      this.$refs.table.getDataAsync();
    },
  },
};
</script>
